import * as React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { Col, Row } from "reactstrap";
import s from "./FooterContainerWidget.module.scss";

interface FooterContainerWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent(
  "FooterContainerWidget",
  ({ widget }: FooterContainerWidgetProps) => {
    if (!widget) return null;
    const columnAmount = widget.get("columnAmount");

    const columnsWidgets = [];
    let customColWidth: Record<string, number> = {
      md: 12 / Number(columnAmount),
      xs: 12,
    };

    for (let i = 1; i <= Number(columnAmount); i += 1) {
      if (Number(columnAmount) === 3) {
        switch (i) {
          case 1: {
            customColWidth = { xl: 2, lg: 3, xs: 12 };
            break;
          }
          case 2: {
            customColWidth = { xl: 7, lg: 5, xs: 12 };
            break;
          }
          case 3: {
            customColWidth = { xl: 3, lg: 4, xs: 12 };
            break;
          }
          default: {
            customColWidth = { xxl: 5, lg: 5, xs: 12 };
          }
        }
      }

      columnsWidgets.push(
        <Col
          key={`footer-column-${i}`}
          data-testid="column"
          {...customColWidth}
        >
          <Scrivito.ContentTag
            content={widget}
            attribute={`widgetarea_${i}`}
            tag="div"
            className={cx(s.footerColumnWidgetArea, "d-flex flex-column")}
          />
        </Col>,
      );
    }

    return <Row className={cx(s.footerRow)}>{columnsWidgets}</Row>;
  },
);
